// extracted by mini-css-extract-plugin
module.exports = {"section":"child-articles_section__KRc95","title":"child-articles_title__qcJSN","browseList":"child-articles_browseList__RfAzc","iconWrapper":"child-articles_iconWrapper__5rNP_"};